const PASSWORD_MANAGER_AUTOCOMPLETE = new Set([
  "email",
  "username",
  "current-password",
  "new-password",
  "one-time-code",
  "tel",
  "name",
]);

export type PasswordManagerFieldSnapshot = {
  name: string;
  autocomplete: string;
  value: string;
  inputMode?: string;
};

export function isPasswordManagerField(autocomplete: string): boolean {
  return PASSWORD_MANAGER_AUTOCOMPLETE.has(autocomplete);
}

export function passwordManagerSubmitValue(
  field: PasswordManagerFieldSnapshot,
): string | null {
  if (!field.name || !isPasswordManagerField(field.autocomplete)) {
    return null;
  }

  if (field.autocomplete === "one-time-code" && field.inputMode === "numeric") {
    return field.value.replace(/[^0-9]/g, "");
  }

  return field.value;
}

export function syncPasswordManagerForm(
  formElement: HTMLFormElement,
  setValue: (name: string, value: string) => void,
): void {
  for (const element of Array.from(formElement.elements)) {
    if (!(element instanceof HTMLInputElement)) continue;

    const next = passwordManagerSubmitValue({
      name: element.name,
      autocomplete:
        element.getAttribute("autocomplete") || element.autocomplete,
      value: element.value,
      inputMode: element.getAttribute("inputmode") || element.inputMode,
    });
    if (next == null || next === "") continue;

    setValue(element.name, next);
  }
}
